import { render, staticRenderFns } from "./otherExpenses.vue?vue&type=template&id=100650f2&"
import script from "./otherExpenses.vue?vue&type=script&lang=js&"
export * from "./otherExpenses.vue?vue&type=script&lang=js&"
import style0 from "./otherExpenses.vue?vue&type=style&index=0&id=100650f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports